import Vue from 'vue'
import Router from 'vue-router'
import axios from 'axios'

// Containers
const TheContainer = () => import('@/containers/TheContainer')

// Views
const Dashboard = () => import('@/views/Dashboard')



// Views - Components

// Views - Buttons

// Views - Icons

// Views - Notifications

// Views - Pages
const Page404 = () => import('@/views/pages/Page404')
const Page500 = () => import('@/views/pages/Page500')
const Login = () => import('@/views/pages/Login')
const SendEmail = () => import('@/views/pages/SendEmail')
const ResetPassword = () => import('@/views/pages/ResetPassword')
const ResetComplete = () => import('@/views/pages/ResetComplete')
const ConfirmEmail = () => import('@/views/pages/ConfirmEmail')
const UserError = () => import('@/views/pages/UserError')

// Users

// Report
const MonthlyReport = () => import('@/report/MonthlyReport')
const Roster = () => import('@/report/Roster')

// (admin)Total
const Total = () => import('@/admin/total/List')
const TotalProject = () => import('@/admin/total/List_project')
const ProjectRateSetting = () => import('@/admin/project/ProjectRateSetting')

// (admin)MonthlyReport
const MonthlyReportList = () => import('@/admin/monthly_report/List')
const MonthlyReportInfo = () => import('@/admin/monthly_report/Info')

// (admin)Roster
const RosterList = () => import('@/admin/roster/List')
const RosterInfo = () => import('@/admin/roster/Info')

// (admin)PaidAndSubstitute
const PaidAndSubstituteListAdmin = () => import('@/admin/paid_and_substitute/List')
const PaidAndSubstituteInfoAdmin = () => import('@/admin/paid_and_substitute/Info')

// (admin)Overtime
const OvertimeListAdmin = () => import('@/admin/overtime/List')
const OvertimeInfoAdmin = () => import('@/admin/overtime/Info')

// (admin)HolidayWork
const HolidayWorkListAdmin = () => import('@/admin/holiday_work/List')
const HolidayWorkInfoAdmin = () => import('@/admin/holiday_work/Info')

// (admin)PayOff/Expense
const ExpenseListAdmin = () => import('@/admin/payoff/ExpenseList')
const ExpenseInfoAdmin = () => import('@/admin/payoff/Expense')

// (admin)PayOff/TravelCost
const TravelCostListAdmin = () => import('@/admin/payoff/TravelCostList')
const TravelCostInfoAdmin = () => import('@/admin/payoff/TravelCostInfo')

// Project
const ProjectRegister = () => import('@/project/ProjectRegister')
const ProjectList = () => import('@/project/ProjectList')
const ProjectInfo = () => import('@/project/ProjectInfo')
const ProjectUpdate = () => import('@/project/ProjectUpdate')

// Department
const DepartmentList = () => import('@/department/List')
const DepartmentInfo = () => import('@/department/Info')
const DepartmentRegisterInput = () => import('@/department/RegisterInput')
const DepartmentUpdateInput = () => import('@/department/UpdateInput')

// Sales
const SalesManagement = () => import('@/admin/sales/SalesManagement')

// Management insights
const WorkforceHeatmap = () => import('@/admin/insights/WorkforceHeatmap')
const OvertimeLimitStatus = () => import('@/admin/insights/OvertimeLimitStatus')
const PaidLeavePlanner = () => import('@/insights/PaidLeavePlanner')
const ProjectProfitForecast = () => import('@/admin/insights/ProjectProfitForecast')
const CashFlowForecast = () => import('@/admin/insights/CashFlowForecast')

// User
const List = () => import('@/user/List')
const Info = () => import('@/user/Info')
const RegisterInput = () => import('@/user/RegisterInput')
const UpdateInput = () => import('@/user/UpdateInput')

// Client
const ClientList = () => import('@/client/ClientList')
const ClientInfo = () => import('@/client/ClientInfo')
const ClientRegister = () => import('@/client/ClientRegister')
const ClientUpdate = () => import('@/client/ClientUpdate')

// Setting
const Setting = () => import('@/setting/Setting')
const SettingUpdate = () => import('@/setting/SettingUpdate')
const CompanyInfoEdit = () => import('@/setting/edit/CompanyInfoEdit')
const AttendanceRuleEdit = () => import('@/setting/edit/AttendanceRuleEdit')
const BusinessHoursEdit = () => import('@/setting/edit/BusinessHoursEdit')
const NotificationEdit = () => import('@/setting/edit/NotificationEdit')
const DisplaySettingEdit = () => import('@/setting/edit/DisplaySettingEdit')
const LoginPolicyEdit = () => import('@/setting/edit/LoginPolicyEdit')
const AdminMfaEdit = () => import('@/setting/edit/AdminMfaEdit')
const HolidayCalendarEdit = () => import('@/setting/edit/HolidayCalendarEdit')
const PaidGrantRuleEdit = () => import('@/setting/edit/PaidGrantRuleEdit')
const InvoiceIssuerEdit = () => import('@/setting/edit/InvoiceIssuerEdit')
const DataImport = () => import('@/setting/DataImport')

// PaidAndSubstitute
const paidAndSubstituteList = () => import('@/request/paid_and_substitute/List')
const paidAndSubstituteInfo = () => import('@/request/paid_and_substitute/Info')
const paidAndSubstituteRegisterInput = () => import('@/request/paid_and_substitute/RegisterInput')
const paidAndSubstituteUpdateInput = () => import('@/request/paid_and_substitute/UpdateInput')

// Overtime
const OvertimeList = () => import('@/request/overtime/List')
const OvertimeInfo = () => import('@/request/overtime/Info')
const OvertimeRegisterInput = () => import('@/request/overtime/RegisterInput')
const OvertimeUpdateInput = () => import('@/request/overtime/UpdateInput')

// HolidayWorks
const HolidayWorkList = () => import('@/request/holiday_work/List')
const HolidayWorkInfo = () => import('@/request/holiday_work/Info')
const HolidayWorkRegisterInput = () => import('@/request/holiday_work/RegisterInput')
const HolidayWorkUpdateInput = () => import('@/request/holiday_work/UpdateInput')

// Request - PayOff
const TravelCost = () => import('@/request/payoff/TravelCost')
const Expense = () => import('@/request/payoff/Expense')

// SubmissionApproval
const ReportList = () => import('@/submission_approval/ReportList')
const SubmissionManagement = () => import('@/submission_approval/SubmissionManagement')

Vue.use(Router)

const router = new Router({
  mode: 'hash', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'active',
  scrollBehavior: () => ({ y: 0 }),
  routes: configRoutes()
})

function configRoutes () {
  return [
    {
      path: '/',
      redirect: '/dashboard',
      component: TheContainer,
      children: [
        {
          path: 'dashboard',
          name: 'Home',
          component: Dashboard,
          meta: { pageTitle: 'ダッシュボード' }
        },
        {
          path: 'insights/paid-leave',
          name: '有休取得計画',
          component: PaidLeavePlanner,
          meta: { requiresAuth: true }
        },
        {
          path: 'admin/insights/workforce',
          name: '人員×プロジェクト稼働',
          component: WorkforceHeatmap,
          /* 見出しはサイドバーの名前に合わせる。name は遷移の識別子。 */
          meta: { requiresAuth: true, pageTitle: '稼働状況分析' }
        },
        {
          /*
           * 36協定アラート。**URLに人のIDを持たない。**
           * 対象月だけで開けるので、F5でも同じ画面へ戻る（年月は
           * 画面の控えから復元する）。行から詳細へ渡すときに
           * params: { value: 行オブジェクト } を使わないこと。
           */
          path: 'admin/insights/overtime-limits',
          name: '36協定アラート',
          component: OvertimeLimitStatus,
          meta: { requiresAuth: true }
        },
        {
          path: 'admin/insights/project-profit',
          name: 'プロジェクト収益予測',
          component: ProjectProfitForecast,
          meta: { requiresAuth: true }
        },
        {
          path: 'admin/insights/cash-flow',
          name: '入出金予測',
          component: CashFlowForecast,
          meta: { requiresAuth: true }
        },
        {
          path: 'project/search/:id',
          name: 'プロジェクト検索詳細',
          component: ProjectInfo,
          meta: { requiresAuth: true }
        },
        {
          path: 'users',
          redirect: '/users/list',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'list',
              name: 'ユーザ管理',
              component: List,
              meta: {
                requiresAuth: true,
                /* 画面上部の見出しは、サイドバーの名前と同じにする。name は
                   遷移の識別子なので変えられない（名前で飛んでいる画面が壊れる）。 */
                pageTitle: 'ユーザー管理'
              },
            },
                {
                  // **:id の経路より前に置く。**
                  //
                  // うしろに置くと :id が "register" を拾って、
                  // 登録画面のURLで**利用者詳細**が出る。名前で飛ぶぶんには
                  // 効かないので、押して入るときは正しく出る——
                  // **F5を押した瞬間に別の画面になる。**
                  path: '/users/register',
                  name: 'ユーザ登録',
                  component: RegisterInput,
                  meta: {
                    requiresAuth: true,
                    /* 見出しは一覧に合わせる。name は遷移の識別子。 */
                    pageTitle: 'ユーザー登録'
                  },
                },
                {
                  path: '/users/:id',
                  name: 'ユーザ詳細',
                  component: Info,
                  meta: {
                    requiresAuth: true,
                    /* 見出しは一覧に合わせる。name は遷移の識別子。 */
                    pageTitle: 'ユーザー詳細'
                  },
                },
                    {
                      path: '/users/:id/edit',
                      name: 'ユーザ更新',
                      component: UpdateInput,
                      meta: {
                        requiresAuth: true,
                        /* 見出しは一覧に合わせる。name は遷移の識別子。 */
                        pageTitle: 'ユーザー更新'
                      },
                    },
          ]
        },
        {
          path: 'department',
          redirect: '/department/list',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'pic',
              name: '組織図',
              component: DepartmentList,
              meta: {
                requiresAuth: true
              },
            },
            {
              path: 'list',
              name: '部署管理',
              component: DepartmentList,
              meta: {
                requiresAuth: true,
                /* 見出しはサイドバーの名前に合わせる。name は遷移の識別子。 */
                pageTitle: '部署一覧'
              },
            },
            {
              path: 'register',
              name: '部署登録',
              component: DepartmentRegisterInput,
              meta: {
                requiresAuth: true
              },
            },
                {
                  path: '/department/:id',
                  name: '部署詳細',
                  component: DepartmentInfo,
                  meta: {
                    requiresAuth: true
                  },
                },
                {
                  path: '/department/:id/edit',
                  name: '部署更新',
                  component: DepartmentUpdateInput,
                  meta: {
                    requiresAuth: true
                  },
                }
          ]
        },
        {
          path: 'paidandsubstitutes',
          name: '休暇申請',
          redirect: '/paidandsubstitutes/list',
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [{
            path: 'list',
            component: paidAndSubstituteList,
            /*
             * 画面上部に出す見出し。
             *
             * ここに何も無いと routePageTitle は製品名を返す。メニューから
             * 開いたのに「PREIKA 勤怠」としか出ず、どこを開いたのか画面が
             * 名乗らない。親の段に name が付いていても、vue-router が見るのは
             * **一致した段**なので出てこない。
             *
             * name のほうは遷移の識別子（ConstList や名前で飛ぶ画面と対）なので
             * 触らない。以下、同じ理由で pageTitle だけ足してある。
             */
            meta: { pageTitle: '休暇申請' }
          }, {
            path: 'list',
            component: {
              render(c) {
                return c('router-view')
              }
            },
            children: [{
              path: '/paidandsubstitutes/:id',
              name: '休暇申請詳細',
              component: paidAndSubstituteInfo
            }, {
              path: '/paidandsubstitutes/:id',
              // **名前は付けない。**この段は入れ子を作るためだけの容器で、
              // 描くのは router-view だけ。本物の「休暇申請詳細」と同じ名前を
              // 付けていたころは vue-router が警告を出していた。先に定義した
              // ほうが勝つので動いてはいたが、並び替えた日に静かに入れ替わり、
              // 名前で飛んだ人が白い画面を見ることになる。
              component: {
                render(c) {
                  return c('router-view')
                }
              },
              children: [{
                path: '/paidandsubstitutes/:id/edit',
                name: '休暇申請修正',
                component: paidAndSubstituteUpdateInput
              }]
            }, {
              path: 'register',
              name: '休暇申請作成',
              component: paidAndSubstituteRegisterInput
            }]
          }]
        },
        {
          path: 'overtimes',
          name: '予定超過残業の申請',
          redirect: '/overtimes/list',
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [{
              path: 'list',
              component: OvertimeList,
              meta: { pageTitle: '予定超過残業の申請' }
            }, {
              path: 'list',
              component: {
                render(c) {
                  return c('router-view')
                }
              },
              children: [{
                  path: '/overtimes/:id',
                  name: '予定超過残業の申請詳細',
                  component: OvertimeInfo
                }, {
                  path: '/overtimes/:id',
                  // **名前は付けない。**この段は入れ子を作るためだけの容器で、
                  // 描くのは router-view だけ。本物の「予定超過残業の申請詳細」と同じ名前を
                  // 付けていたころは vue-router が警告を出していた。先に定義した
                  // ほうが勝つので動いてはいたが、並び替えた日に静かに入れ替わり、
                  // 名前で飛んだ人が白い画面を見ることになる。
                  component: {
                    render(c) {
                      return c('router-view')
                    }
                },
                children: [{
                  path: '/overtimes/:id/edit',
                  name: '予定超過残業の申請修正',
                  component: OvertimeUpdateInput
                }]
              },
              {
                path: 'register',
                name: '予定超過残業の申請作成',
                component: OvertimeRegisterInput
              }]
          }]
        },
        {
          path: 'holidayworks',
          name: '休日出勤報告',
          redirect: '/holidayworks/list',
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [{
            path: 'list',
            component: HolidayWorkList,
            meta: { pageTitle: '休日出勤報告' }
          }, {
            path: 'list',
            component: {
              render(c) {
                return c('router-view')
              }
            },
            children: [{
              path: '/holidayworks/:id',
              name: '休日出勤報告詳細',
              component: HolidayWorkInfo
            }, {
              path: '/holidayworks/:id',
              // **名前は付けない。**この段は入れ子を作るためだけの容器で、
              // 描くのは router-view だけ。本物の「休日出勤報告詳細」と同じ名前を
              // 付けていたころは vue-router が警告を出していた。先に定義した
              // ほうが勝つので動いてはいたが、並び替えた日に静かに入れ替わり、
              // 名前で飛んだ人が白い画面を見ることになる。
              component: {
                render(c) {
                  return c('router-view')
                }
              },
              children: [{
                path: '/holidayworks/:id/edit',
                name: '休日出勤報告修正',
                component: HolidayWorkUpdateInput
              }]
            }, {
              path: 'register',
              name: '休日出勤報告作成',
              component: HolidayWorkRegisterInput
            }]
          }]
        },
        {
          path: 'client',
          redirect: '/client/list',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'list',
              name: 'クライアント管理',
              component: ClientList,
              /* 見出しはサイドバーの名前に合わせる。name は遷移の識別子で、
                 ConstList.ROUTE_CLIENT_LIST から名前で飛んでいる。 */
              meta: { pageTitle: '取引先情報' }
            },
            {
              path: 'list',
              // **名前は付けない。**この段は入れ子を作るためだけの容器で、
              // 描くのは router-view だけ。本物の「クライアント管理」と同じ名前を
              // 付けていたころは vue-router が警告を出していた。先に定義した
              // ほうが勝つので動いてはいたが、並び替えた日に静かに入れ替わり、
              // 名前で飛んだ人が白い画面を見ることになる。
              component: {
                render (c) { return c('router-view') }
              },
              children: [
                {
                  path: 'clientinfo',
                  name: 'クライアント詳細',
                  component: ClientInfo,
                  /* 見出しは一覧に合わせる。name は ConstList.ROUTE_CLIENT_INFO と
                     対になった遷移の識別子なので変えられない。 */
                  meta: { pageTitle: '取引先詳細' }
                },
                {
                  path: 'clientinfo',
                  // **名前は付けない。**この段は入れ子を作るためだけの容器で、
                  // 描くのは router-view だけ。本物の「クライアント詳細」と同じ名前を
                  // 付けていたころは vue-router が警告を出していた。先に定義した
                  // ほうが勝つので動いてはいたが、並び替えた日に静かに入れ替わり、
                  // 名前で飛んだ人が白い画面を見ることになる。
                  component: {
                    render (c) { return c('router-view') }
                  },
                  children: [
                    {
                      path: 'clientupdate',
                      name: 'クライアント更新',
                      component: ClientUpdate,
                      /* 見出しは一覧に合わせる。name は遷移の識別子。 */
                      meta: { pageTitle: '取引先更新' }
                    }
                  ]
                },
                {
                  path: 'clientregister',
                  name: 'クライアント登録',
                  component: ClientRegister,
                  /* 見出しは一覧に合わせる。name は遷移の識別子。 */
                  meta: { pageTitle: '取引先登録' }
                }
              ]
            }
          ]
        },
        {
          path: 'project',
          redirect: '/project/list',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'list',
              name: 'プロジェクト管理',
              component: ProjectList
            },
            {
              path: 'list',
              // **名前は付けない。**この段は入れ子を作るためだけの容器で、
              // 描くのは router-view だけ。本物の「プロジェクト管理」と同じ名前を
              // 付けていたころは vue-router が警告を出していた。先に定義した
              // ほうが勝つので動いてはいたが、並び替えた日に静かに入れ替わり、
              // 名前で飛んだ人が白い画面を見ることになる。
              component: {
                render (c) { return c('router-view') }
              },
              children: [
                {
                  path: 'projectinfo',
                  name: 'プロジェクト詳細',
                  component: ProjectInfo
                },
                {
                  path: 'projectinfo',
                  // **名前は付けない。**この段は入れ子を作るためだけの容器で、
                  // 描くのは router-view だけ。本物の「プロジェクト詳細」と同じ名前を
                  // 付けていたころは vue-router が警告を出していた。先に定義した
                  // ほうが勝つので動いてはいたが、並び替えた日に静かに入れ替わり、
                  // 名前で飛んだ人が白い画面を見ることになる。
                  component: {
                    render (c) { return c('router-view') }
                  },
                  children: [
                    {
                      path: 'projectupdate',
                      name: 'プロジェクト更新',
                      component: ProjectUpdate
                    }
                  ]
                },
                {
                  path: 'projectreister',
                  name: 'プロジェクト登録',
                  component: ProjectRegister
                }
              ]
            }
          ]
        },
         {
          path: 'setting',
          redirect: '/setting/info',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'info',
              name: '設定',
              component: Setting,
              meta: {
                requiresAuth: true
              },
            },
            /*
             * **1項目ずつ直す画面。**
             *
             * 権限は accessPolicy の prefix '/setting' が前方一致で
             * 見ているので、ここへ足しても守りから漏れない
             * （SYSTEM_SETTING ＋ SYSTEM_SETTING_MANAGE）。
             */
            {
              path: 'edit/company',
              name: '自社設定の会社情報',
              component: CompanyInfoEdit,
              meta: {
                requiresAuth: true
              },
            },
            {
              path: 'edit/attendance',
              name: '自社設定の勤怠計算',
              component: AttendanceRuleEdit,
              meta: {
                requiresAuth: true
              },
            },
            {
              path: 'edit/business-hours',
              name: '自社設定の就業時間',
              component: BusinessHoursEdit,
              meta: {
                requiresAuth: true
              },
            },
            {
              path: 'edit/notification',
              name: '自社設定の通知',
              component: NotificationEdit,
              meta: {
                requiresAuth: true
              },
            },
            {
              path: 'edit/display',
              name: '自社設定の表示',
              component: DisplaySettingEdit,
              meta: {
                requiresAuth: true
              },
            },
            /*
             * 一覧からたたんで追い出したぶん。**部品も保存の口も
             * そのまま。**置き場所だけを変えている。
             *
             * 権限はここでも動かない。accessPolicy の prefix
             * '/setting' が前方一致で見ているので、同じ守り
             * （SYSTEM_SETTING ＋ SYSTEM_SETTING_MANAGE）に入る。
             */
            {
              path: 'edit/login-policy',
              name: '自社設定のログイン方法',
              component: LoginPolicyEdit,
              meta: {
                requiresAuth: true
              },
            },
            {
              path: 'edit/admin-mfa',
              name: '自社設定の管理者2要素認証',
              component: AdminMfaEdit,
              meta: {
                requiresAuth: true
              },
            },
            {
              path: 'edit/holiday-calendar',
              name: '自社設定の休日カレンダー',
              component: HolidayCalendarEdit,
              meta: {
                requiresAuth: true
              },
            },
            {
              path: 'edit/paid-leave-rules',
              name: '有休付与ルールの表',
              component: PaidGrantRuleEdit,
              meta: {
                requiresAuth: true
              },
            },
            /*
             * 請求書記載情報（住所・インボイス登録番号・振込先など）。
             * 取引先向けの請求書（請求書管理）に載る、自社の情報を入れる画面。
             *
             * 保存の口は専用（/setting/invoice-issuer）。権限はここでも
             * accessPolicy の prefix '/setting' の前方一致に入る
             * （SYSTEM_SETTING ＋ SYSTEM_SETTING_MANAGE）。
             */
            {
              path: 'edit/invoice-issuer',
              name: '自社設定の請求書記載情報',
              component: InvoiceIssuerEdit,
              meta: {
                requiresAuth: true
              },
            },
            /*
             * 他社からの乗り換えで、まとめて入れる画面。
             *
             * **自社設定の下に置く。**会社のマスタを作る操作なので、
             * 触ってよい人は設定を触ってよい人と同じ。
             */
            {
              path: 'data-import',
              name: 'データの取り込み',
              component: DataImport,
              meta: {
                requiresAuth: true
              },
            },
            /*
             * **まとめて直す画面。**1項目ずつの画面ができたので、
             * ふだんはこちらを開かない。36協定はここにしか無いので残す。
             *
             * ここは前まで `path: 'info'` の入れ子で書いてあり、
             * **同じ path と同じ name（'設定'）が2つ**あった。
             * Vue Router は名前が重なると片方を捨てるので、
             * <b>どちらが生きているのか読んでも分からない</b>状態だった。
             * URL は変えずに、入れ子をやめて1本にしてある。
             */
            {
              path: 'info/SettingUpdate',
              name: '設定更新',
              component: SettingUpdate,
              meta: {
                requiresAuth: true
              },
            }
          ]
        },
        {
          path: 'report',
          redirect: '/report/monthlyreport',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'monthlyreport',
              name: '業務報告',
              component: MonthlyReport
            },
            {
              path: 'roster',
              name: '勤務表',
              component: Roster
            },
          ]
        },
        {
          path: 'admin/monthlyreports',
          redirect: '/admin/monthlyreports/list',
          name: '業務報告一覧',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'list',
              component: MonthlyReportList,
              meta: {
                pageTitle: '業務報告一覧',
                requiresAuth: true
              },
            },
            {
              path: ':id/:user_id/:year/:month',
              name: '業務報告詳細',
              component: MonthlyReportInfo,
              meta: {
                requiresAuth: true
              },
            }
          ]
        },
        {
          path: 'admin/total',
          redirect: '/admin/total/list',
          name: '月次集計',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'list',
              component: Total,
              meta: {
                pageTitle: '月次集計',
                requiresAuth: true
              },
            }
          ]
        },
        {
          path: 'admin/project-rate',
          /* 見出しはサイドバーの名前に合わせる。name は遷移の識別子。 */
          name: 'プロジェクト単価設定',
          component: ProjectRateSetting,
          meta: {
            requiresAuth: true,
            pageTitle: 'プロジェクト金額設定'
          }
        },
        {
          path: 'admin/sales',
          redirect: '/admin/sales/salesManagement',
          name: '売上・請求書管理',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'salesManagement',
              component: SalesManagement,
              meta: {
                pageTitle: '請求書管理',
                requiresAuth: true
              },
            },
          ]
        },
        {
          path: 'admin/total',
          redirect: '/admin/total/list_project',
          name: '期間集計',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'list_project',
              component: TotalProject,
              meta: {
                pageTitle: 'プロジェクト集計',
                requiresAuth: true
              },
            }
          ]
        },
        {
          path: 'admin/roster',
          redirect: '/admin/roster/list',
          name: '勤務表一覧',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'list',
              component: RosterList,
              meta: {
                pageTitle: '勤務表一覧',
                requiresAuth: true
              },
            },
            {
              path: ':user_id/:year/:month/:user_name',
              name: '勤務表詳細',
              component: RosterInfo,
              meta: {
                requiresAuth: true
              },
            }
          ]
        },
        {
          path: 'admin/paidandsubstitute',
          redirect: '/admin/paidandsubstitute/list',
          name: '休暇申請一覧',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'list',
              component: PaidAndSubstituteListAdmin,
              meta: {
                pageTitle: '休暇申請一覧',
                requiresAuth: true
              },
            },
            {
              path: ':id',
              name: '休暇申請詳細(管理者)',
              component: PaidAndSubstituteInfoAdmin,
              meta: {
                requiresAuth: true
              },
            }
          ]
        },
        {
          path: 'admin/overtime',
          redirect: '/admin/overtime/list',
          name: '予定超過残業の申請一覧',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'list',
              component: OvertimeListAdmin,
              meta: {
                pageTitle: '予定超過残業の申請一覧',
                requiresAuth: true
              },
            },
            {
              path: ':id',
              name: '予定超過残業の申請詳細(管理者)',
              component: OvertimeInfoAdmin,
              meta: {
                requiresAuth: true
              },
            }
          ]
        },
        {
          path: 'admin/holidaywork',
          redirect: '/admin/holidaywork/list',
          name: '休日出勤報告一覧',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'list',
              component: HolidayWorkListAdmin,
              meta: {
                pageTitle: '休日出勤報告一覧',
                requiresAuth: true
              },
            },
            {
              path: ':id',
              name: '休日出勤報告詳細(管理者)',
              component: HolidayWorkInfoAdmin,
              meta: {
                requiresAuth: true
              },
            }
          ]
        },
        {
          path: 'admin/payoff',
          redirect: 'admin/payoff/expenseList',
          name: '経費精算一覧',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'expenseList',
              component: ExpenseListAdmin,
              meta: {
                pageTitle: '経費精算一覧',
                requiresAuth: true
              },
            },
            {
              path: '/expenseList/:user_id/:year/:month',
              name: '経費精算詳細(管理者)',
              component: ExpenseInfoAdmin,
              meta: {
                requiresAuth: true
              },
            },
          ]
        },
        {
          path: 'admin/payoff',
          redirect: 'admin/payoff/travelCostList',
          name: '通勤費精算一覧',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              // **コロンを付けない。**「:travelCostList」と書いてあったので
              // 動く部分ではなく**受け皿**になっていた。/admin/payoff/でたらめ でも
              // /admin/payoff/123 でも、この一覧が出ていた（実測）。
              // travelCostList という文字が当たっていたのは偶然。
              path: 'travelCostList',
              component: TravelCostListAdmin,
              meta: {
                pageTitle: '通勤費精算一覧',
                requiresAuth: true
              },
            },
            {
              path: '/travelCostList/:user_id/:year/:month',
              name: '通勤費精算詳細(管理者)',
              component: TravelCostInfoAdmin,
              meta: {
                requiresAuth: true
              },
            },
          ]
        },
        {
          path: 'payoff',
          redirect: '/payoff/expense',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'expense',
              name: '経費精算',
              component: Expense
            }
          ]
        },
        {
          path: 'payoff',
          redirect: '/payoff/travelCost',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'travelCost',
              name: '通勤費精算',
              component: TravelCost
            },
          ]
        },
        {
          path: 'submission_approval',
          redirect: '/submission_approval/report_list',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'report_list',
              name: '自分の申請一覧',
              component: ReportList
            }
          ]
        },
        {
          path: 'submission_approval',
          redirect: '/submission_approval/submission_management',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'submission_management',
              name: '承認待ちの申請',
              component: SubmissionManagement
            }
          ]
        },
      ]
    },
    /*
     * 古い /login を、いまのログイン画面へ寄せる。**印を落とさずに。**
     *
     * ログイン画面の実パスは /pages/login。ところがサーバは長いあいだ
     * /#/login?mfa=1 のような行き先を返していた。一致するルートが無く、
     * catch-all も無いので、見張りが名前指定で送り直し、**クエリが落ちた**。
     *
     * 落ちると印が Login.vue へ届かない。**Google と Microsoft で入って
     * 2要素が要る人は、確認コードの欄が出ないまま何度も同じところへ
     * 戻された。**パスワードを持たない人は回り込む手段も無い。
     *
     * サーバ側は直したが、ここも残す。**古いブックマークと、まだ入れ替えて
     * いないサーバから来る人がいる。**
     *
     * query: to.query は**書かなくても同じ**。vue-router の redirect は
     * 行き先が query を指定していなければ元の query を引き継ぐ
     * （壊して確かめた: 外しても印は残る）。効いているのは
     * **この寄せる道が在ること**のほうで、道ごと外すとテストが落ちる。
     * それでも明示して残すのは、読む人がここで引き継ぎの有無を
     * 調べ直さずに済むため。
     */
    {
      path: '/login',
      redirect: function (to) {
        return { name: 'Login', query: to.query }
      }
    },
    {
      path: '/pages',
      redirect: '/pages/404',
      name: 'Pages',
      component: {
        render (c) { return c('router-view') }
      },
      children: [
        {
          path: '404',
          name: 'Page404',
          component: Page404
        },
        {
          path: '500',
          name: 'Page500',
          component: Page500
        },
        {
          path: 'login',
          name: 'Login',
          component: Login
        },
        {
          path: 'sendEmail',
          name: 'SendEmail',
          component: SendEmail,
          /*
           * 使えなかった再設定リンクから来たときの印（notice）を受け取る
           * （束23）。印は params で渡すので、読み込み直すと消える——
           * 古い知らせを出し続けない。
           */
          props: true
        },
        {
          path: 'confirmEmail',
          name: 'ConfirmEmail',
          component: ConfirmEmail,
          props: true
        },
        {
          path: 'resetPassword',
          name: 'ResetPassword',
          component: ResetPassword,
          props: route => ({
            id: route.query.id,
            token: route.query.token
          })
        },
        {
          path: 'resetComplete',
          name: 'ResetComplete',
          component: ResetComplete
        },
        {
          path: 'user_error',
          name: 'UserError',
          component: UserError
        }
      ]
    }
  ]
}

router.beforeEach((to, from, next) => {
  if (to.name === 'ConfirmEmail') {
    if (to.params.email) {
      next()
    } else {
      next({
        name: 'Login'
      })
    }
    return
  }

  if (to.name === 'ResetPassword') {
    // 合言葉をURLに載せない。
    //
    // 問い合わせ行に入れると、手前のプロキシのアクセスログ・ブラウザの
    // 履歴・外部サイトへ飛んだときの Referer に、そのまま残る。
    // ログを読める人が、期限内ならそのリンクをそのまま使える。
    axios
      .post(process.env.VUE_APP_API_ORIGIN + '/token/check', {
        token: to.query.token
      })
      .then(response => {
        if (response.data === true) {
          next()
        } else {
          /*
           * **使えないリンクは、再設定メールの画面へ移す**（束23）。
           *
           * 2026-09-30 まで、ここは小窓で「トークンの有効期限が切れました。」
           * と言ってログイン画面へ飛ばしていた。使えない理由は3つ（15分の
           * 期限切れ・新しいメールを送ったので無効・使用済み）あり、
           * どれでも次にすることは「もう一度メールを送る」。理由の文は
           * 移った先が出す。小窓は閉じるまで次へ進めないので使わない。
           */
          next({
            name: 'SendEmail',
            params: { notice: 'link-unusable' }
          })
        }
      })
      .catch(() => {
        /*
         * **通信の失敗は、通信の失敗として伝える**（束23）。以前は何も
         * 言わずにログイン画面へ移っていた。リンクが使えるかどうかは
         * 分からないので「期限切れ」とは言わない。
         */
        next({
          name: 'SendEmail',
          params: { notice: 'link-check-failed' }
        })
      })
    return
  }

  if (to.name === 'Login' || to.name === 'SendEmail' || to.name === 'ResetComplete') {
    next()
    return
  }

  axios
    .get((process.env.VUE_APP_API_ORIGIN) + '/name')
    .then(response => {
      if (response.data && response.status === 200) {
        next()
      } else {
        next({
          name: 'Login'
        })
      }
    })
    .catch(() => {
      next({
        name: 'Login'
      })
    })
})
export default router

